var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_374_1970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.46164 14.9636L18.6034 27.1013C19.1362 27.6327 19.9994 27.6327 20.5335 27.1013C21.0663 26.5699 21.0663 25.7067 20.5335 25.1753L9.35478 14.0006L20.5321 2.82595C21.0649 2.29452 21.0649 1.43134 20.5321 0.898571C19.9994 0.367143 19.1348 0.367143 18.6021 0.898571L6.46029 13.0362C5.9357 13.5621 5.9357 14.4389 6.46164 14.9636Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_374_1970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.6302bfcab938f527c2a7b3d29b156768.svg";
export { ForwardRef as ReactComponent };